var map = {
	"./ai.png": 428,
	"./computer_literacy.png": 429,
	"./ege-informatika-desk.png": 355,
	"./ege-informatika.png": 356,
	"./frontend.png": 430,
	"./game_design.png": 431,
	"./graphic_design.png": 432,
	"./math-desk.png": 357,
	"./math.png": 358,
	"./predprinimatelstvo.png": 433,
	"./programming_basics.png": 434,
	"./python.png": 435,
	"./scratch.png": 436,
	"./unity.png": 437,
	"./videoblogging.png": 438,
	"./web-razrabotka.png": 439
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 782;